const skyObjectTypeMap = {
  skyObjectType: {
    xxxx: { type: "TYPE_UNKNOWN", value: 0 },
    Sxxx: { type: "TYPE_SINGLE_STAR", value: 1 },
    SMxx: { type: "TYPE_DOUBLE_STAR", value: 2 },
    SM2x: { type: "TYPE_BINARY_STAR", value: 3 },
    SMxV: { type: "TYPE_DBL_VAR_STAR", value: 4 },
    SM2V: { type: "TYPE_BIN_VAR_STAR", value: 5 },
    SxxV: { type: "TYPE_VARIABLE_STAR", value: 6 },
    SxxS: { type: "TYPE_SUPERNOVA", value: 7 },
    SxxX: { type: "TYPE_NON_STAR", value: 9 },
    Kxxx: { type: "TYPE_DEEP_STAR", value: 10 },
    KOxx: { type: "TYPE_OPEN_CLUSTER", value: 11 },
    KGxx: { type: "TYPE_GLOBULAR_CLUSTER", value: 12 },
    NDxx: { type: "TYPE_BRIGHT_NEBULA", value: 13 },
    Ndxx: { type: "TYPE_DARK_NEBULA", value: 14 },
    NPxx: { type: "TYPE_PLANETARY_NEBULA", value: 15 },
    Gxxx: { type: "TYPE_GALAXY", value: 16 },
    GSxx: { type: "TYPE_SPIRAL_GALAXY", value: 17 },
    GExx: { type: "TYPE_ELLIPTICAL_GALAXY", value: 18 },
    GIxx: { type: "TYPE_IRREGULAR_GALAXY", value: 19 },
    OQxx: { type: "TYPE_QUASAR", value: 20 },
    ORxx: { type: "TYPE_RADIO_SOURCE", value: 21 },
    OXxx: { type: "TYPE_XRAY_SOURCE", value: 22 },
    OMxx: { type: "TYPE_GAMMA_SOURCE", value: 23 },
    OBxx: { type: "TYPE_BLACK_HOLE", value: 24 },
    Xxxx: { type: "TYPE_NON_DEEP_SKY", value: 29 },
    sPxx: { type: "TYPE_PLANET", value: 30 },
    sMxx: { type: "TYPE_MOON", value: 31 },
    MPxx: { type: "TYPE_SPACECRAFT", value: 32 },
    sAxx: { type: "TYPE_ASTEROID", value: 33 },
    sCxx: { type: "TYPE_COMET", value: 34 },
    MSxx: { type: "TYPE_SATELLITE", value: 35 },
    Fxxx: { type: "TYPE_PLANET_FEATURE", value: 39 },
    CCxx: { type: "TYPE_CONSTELLATION", value: 40 },
    CAxx: { type: "TYPE_ASTERISM", value: 41 },
    ssxx: { type: "TYPE_METEOR_SHOWER", value: 42 },
  },

  getTypeByAbbrev: function (typeAbbrev) {
    return this.skyObjectType[typeAbbrev] || this.skyObjectType.xxxx;
  },
};

export default skyObjectTypeMap;
